@if (isLoading) {
    <app-spinner></app-spinner>
} @else {
    <span class="h-10" [innerHTML]="svgIcon"></span>
}


